const FREE_CONTACT_LIMIT = 20;

export function isContactLimitModel(contactLimit) {
  return !!contactLimit;
}

export function isFreeContactLimitModelTier(contactLimit) {
  return isContactLimitModel(contactLimit) && contactLimit <= FREE_CONTACT_LIMIT;
}

export function isPaidContactLimitModelTier(contactLimit) {
  return isContactLimitModel(contactLimit) && contactLimit > FREE_CONTACT_LIMIT;
}